export default __webpack_public_path__ + "80c07943565d91b976e1e9cdd77d03fb.ttf";